module.exports = __webpack_public_path__ + "img/map.16205a2.png";